import { createSlice } from "@reduxjs/toolkit";

interface ThemeReducerInterface {
  theme: "dark" | "light";
}

const initState: ThemeReducerInterface = {
  theme: "light",
};

export const themeSlice = createSlice({
  name: "theme",
  initialState: initState,
  reducers: {
    setTheme: (state: ThemeReducerInterface, action) => {
      let tempObj = { ...state, ...action.payload };
      return tempObj;
    },
    resetTheme: () => initState,
  },
});

export const { setTheme, resetTheme } = themeSlice.actions;

export default themeSlice.reducer;
